import React, { useEffect } from "react";
import './css/index.scss';

import commonComponents from "../../components/common";

import global from "../../config/global";
import { convertStringToQuery } from '../../secrets-web/src/utils/common'

const Login = () => {
  const { BusyOverlay } = commonComponents;
  const query = convertStringToQuery(window.location.search);

  useEffect(() => {
    window.location.replace(`${global.urls.LOCKER_ID_URL}/login?SERVICE_URL=${query?.return_url || '/'}&SERVICE_SCOPE=${global.constants.SERVICE_SCOPE}&ENVIRONMENT=${global.constants.ENVIRONMENT}`)
  }, [])

  return (
    <div className="auth-page">
      <BusyOverlay />
    </div>
  );
}

export default Login;